module.exports = __webpack_public_path__ + "img/estate.b9e8928a.jpg";